import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import UserLogin from "./screens/UserLogin";
import UserScreen from "./screens/UserScreen";
import NuevaCita from "./screens/NuevaCita";
import MisCitas from "./screens/MisCitas";
import MisDatos from "./screens/MisDatos";
import Paso1Cita from "./screens/Paso1Cita";
import Paso2Cita from "./screens/Paso2Cita";
import Paso3Cita from "./screens/Paso3Cita";
import qrcita from "./screens/qrcita";
import CodigoSMS from "./screens/CodigoSMS";
import CambiarContrasena from "./screens/CambiarContrasena";
import OlvideContrasena from "./screens/OlvideContrasena";
import ConfirmarCita from "./screens/ConfirmarCita";
import AdminScreen from "./screens/AdminScreen";
import AnadirHorarios from "./screens/AnadirHorarios";
import Disponibilidad from "./screens/Disponibilidad";
import Permisos from "./screens/Permisos";
import Citas from "./screens/Citas";
import SeleccionarInstalaciones from "./screens/SeleccionarInstalaciones";
import ConfirmacionCita from "./screens/ConfirmacionCita";
import { useFonts } from "@use-expo/font";
import { AppLoading } from "expo";
import AnadirPeriodo from "./screens/AnadirPeriodo";
import { CardStyleInterpolators } from "@react-navigation/stack";
import UserRegister from "./screens/UserRegister";
import QrReader from "./screens/QrReader";
import { AsyncStorage } from "react-native";
import makeRequest from "./components/makeRequest";
import ConfigurarHorarios from "./screens/ConfigurarHorarios";
const Stack = createStackNavigator();
import { Notifications } from "expo";

export default function App(props) {
  const [isAuth, setAuth] = useState("");
  const [notification, setNotification] = useState({});

  const _handleNotification = async (notification) => {
    setNotification(notification);
    if (notification.data.cita && notification.data.cita._id) {
      Notifications.cancelScheduledNotificationAsync(
        await AsyncStorage.getItem(notification.data.cita._id + "-final")
      );
      Notifications.cancelScheduledNotificationAsync(
        await AsyncStorage.getItem(notification.data.cita._id + "-inicio")
      );
    }
  };
  useEffect(() => {
    const _notificationSubscription = Notifications.addListener(
      _handleNotification
    );
    const isAuth = async () => {
      if (await AsyncStorage.getItem("x-citaprevia-token").catch(() => false)) {
        const response = await makeRequest("users/me", "get");
        if (response[0] == 200 && response[1].adminLevel > 0) {
          setAuth("AdminScreen");
          return;
        } else if (response[0] == 200 && response[1].confirmado) {
          setAuth("UserScreen");
          return;
        } else if (response[0] == 200 && !response[1].confirmado) {
          setAuth("CodigoSMS");
          return;
        } else {
          setAuth("UserLogin");
        }
      } else setAuth("UserLogin");
    };
    isAuth();
  }, []);
  let [fontsLoaded] = useFonts({
    "Nunito-Bold": require("./assets/fonts/NunitoSans-Bold.ttf"),
    "Nunito-Light": require("./assets/fonts/NunitoSans-Light.ttf"),
    "Nunito-Regular": require("./assets/fonts/NunitoSans-Regular.ttf"),
    "Nunito-Black": require("./assets/fonts/NunitoSans-Black.ttf"),
    "Montserrat-Bold": require("./assets/fonts/Montserrat-Bold.ttf"),
    "Montserrat-Regular": require("./assets/fonts/Montserrat-Regular.ttf"),
  });
  const options = {
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  if (!fontsLoaded || isAuth == "") {
    return <AppLoading />;
  } else {
    return (
      <View style={styles.container}>
        <NavigationContainer>
          <Stack.Navigator headerMode='none' initialRouteName={isAuth}>
            <Stack.Screen
              name='UserLogin'
              component={UserLogin}
              options={options}
            />
            <Stack.Screen
              name='UserScreen'
              component={UserScreen}
              options={options}
            />
            <Stack.Screen
              name='UserRegister'
              component={UserRegister}
              options={options}
            />
            <Stack.Screen
              name='NuevaCita'
              component={NuevaCita}
              options={options}
            />
            <Stack.Screen
              name='MisCitas'
              component={MisCitas}
              options={options}
            />
            <Stack.Screen
              name='MisDatos'
              component={MisDatos}
              options={options}
            />
            <Stack.Screen
              name='Paso1Cita'
              component={Paso1Cita}
              options={options}
            />
            <Stack.Screen
              name='Paso2Cita'
              component={Paso2Cita}
              options={options}
            />
            <Stack.Screen
              name='Paso3Cita'
              component={Paso3Cita}
              options={options}
            />
            <Stack.Screen
              name='ConfirmarCita'
              component={ConfirmarCita}
              options={options}
            />
            <Stack.Screen
              name='ConfirmacionCita'
              component={ConfirmacionCita}
              options={options}
            />
            <Stack.Screen
              name='AdminScreen'
              component={AdminScreen}
              options={options}
            />
            <Stack.Screen
              name='ConfigurarHorarios'
              component={ConfigurarHorarios}
              options={options}
            />
            <Stack.Screen
              name='AnadirHorarios'
              component={AnadirHorarios}
              options={options}
            />
            <Stack.Screen name='Citas' component={Citas} options={options} />
            <Stack.Screen
              name='SeleccionarInstalaciones'
              component={SeleccionarInstalaciones}
              options={options}
            />
            <Stack.Screen
              name='Disponibilidad'
              component={Disponibilidad}
              options={options}
            />
            <Stack.Screen
              name='Permisos'
              component={Permisos}
              options={options}
            />
            <Stack.Screen
              name='AnadirPeriodo'
              component={AnadirPeriodo}
              options={options}
            />
            <Stack.Screen name='qrcita' component={qrcita} options={options} />
            <Stack.Screen
              name='QrReader'
              component={QrReader}
              options={options}
            />
            <Stack.Screen
              name='CodigoSMS'
              component={CodigoSMS}
              options={options}
            />
            <Stack.Screen
              name='CambiarContrasena'
              component={CambiarContrasena}
              options={options}
            />
            <Stack.Screen
              name='OlvideContrasena'
              component={OlvideContrasena}
              options={options}
            />
          </Stack.Navigator>
        </NavigationContainer>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
});
